export default __webpack_public_path__ + "static/bravemark-prizes1@2x-f2307f5350ee1445242327657364057a.png";